import React from 'react';
import Panel from '../../layout/Panel';
import { Insights as StudioIcon } from '@mui/icons-material';
import Studio from './Studio';

export default function RagStudio() {
  return (
    <Panel 
      title="RAG Quality Studio"
      icon={<StudioIcon />}
      contentSx={{ p: 0, height: '100%' }}
    >
      <Studio />
    </Panel>
  );
}